import { Component } from "@angular/core";
import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { AuthCredentials } from "app/shared/data/auth-credentials";
import { AuthRegister } from "app/shared/data/auth-register";


@Component({
    selector: 'logon',
    templateUrl: 'logon.component.html'})
  export class LogonComponent {

    model = new AuthRegister("","","","");
    error:String = null;
    registerOk = false;

    constructor(
                private authService: AuthService,
                private router: Router) {
    }

    logon() {
      console.log("Logon " + this.model.username);
      if (this.model.username && this.model.password && this.model.email && this.model.name) {
          let promise = this.authService.register(this.model);
          promise.then(
                res=> this.handleLogonResult(res),
                msg=> console.log(msg)
            );
      }
    }

    private handleLogonResult(res: String) {
        if (res=="OK") {
            console.log("User is registered in");
            this.registerOk = true;
        } else {
            this.error = res;
            console.log(res);
        }
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/security/logon.component.ts